import { Challenge } from '@wix/ambassador-challenges-v1-challenge/types';
import { ProgramAccessType } from '../types/programs';

export function isPrivateChallenge(challenge: Challenge) {
  return (
    challenge?.settings?.accessRestrictions?.accessType ===
    ProgramAccessType.PRIVATE
  );
}
